<template>
    <a-select
        :get-popup-container="(triggerNode) => triggerNode.parentNode"
        :default-value="value"
        :value="value"
        :disabled="!!disabled"
        style="width: 100%;"
        @change="onChange"
    >
        <a-select-option
            v-for="item in store"
            :key="item.id"
        >
            {{ item.name }}
        </a-select-option>
    </a-select>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        value: {
            type: Number,
            default: null,
        },
        disabled: Boolean,
    },
    emits: ['change'],
    data() {
        return {
            store: [],
        };
    },
    mounted() {
        this.loadStore();
    },
    methods: {
        loadStore() {
            this.$http.get('/clinics').then((response) => {
                this.store = response.data;
                if (!this.value && this.store.length === 1) {
                    this.onChange(this.store[0].id);
                }
            }).catch(() => {});
        },
        onChange(value) {
            this.$emit('change', value);
        },
    },
});
</script>

<style lang="scss">
.ant-select-dropdown-content {
    text-align: left;
}
</style>
